import { render } from "./footerComponent.vue?vue&type=template&id=87c119fe&scoped=true&ts=true"
import script from "./footerComponent.vue?vue&type=script&lang=ts"
export * from "./footerComponent.vue?vue&type=script&lang=ts"

import "./footerComponent.vue?vue&type=style&index=0&id=87c119fe&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87c119fe"]])

export default __exports__